


































































































































































































































































import store from '../../../store'
import PageTitle from '../../../components/PageTitle.vue'
import dayjs from 'dayjs'
import TableModal from '../../../components/TableModal.vue'
import Table14 from '../tables/Table14.vue'
import Table15 from '../tables/Table15.vue'
import { print } from '../../../mla-shared'

export default {
  data: (vm:any) => {
    return {
      name: 'Scenario 1',
      date: dayjs().format('YYYY-MM-DD'),
      startDate: dayjs().format('YYYY-MM-DD'),
      menu: false,
      mobs: [{ name: 'Mob 1', class: null, colour: '#ffffff', number: 0, dse: 0 }],
      paddockData: [],
      paddock: {
        name: 'Paddock...',
        area: 0,
        f1: null,
        f2: null,
        f3: null,
        f4: null,
        f5: null,
        f6: null,
        f7: null,
        f8: null,
        f9: null,
        f10: null,
        f11: null,
        f12: null,
        f13: null,
        f14: null,
        f15: null,
        f16: null,
        f17: null,
        f18: null,
        f19: null,
        f20: null,
        f21: null,
        f22: null,
        f23: null,
        f24: null,
        f25: null,
        f26: null
      },
      paddockHeaders: [
        { text: 'Name', value: 'name' },
        { text: 'Area (ha)', value: 'area' },
        { text: 'F1', value: 'f1' },
        { text: 'F2', value: 'f2' },
        { text: 'F3', value: 'f3' },
        { text: 'F4', value: 'f4' },
        { text: 'F5', value: 'f5' },
        { text: 'F6', value: 'f6' },
        { text: 'F7', value: 'f7' },
        { text: 'F8', value: 'f8' },
        { text: 'F9', value: 'f9' },
        { text: 'F10', value: 'f10' },
        { text: 'F11', value: 'f11' },
        { text: 'F12', value: 'f12' },
        { text: 'F13', value: 'f13' },
        { text: 'F14', value: 'f14' },
        { text: 'F15', value: 'f15' },
        { text: 'F16', value: 'f16' },
        { text: 'F17', value: 'f17' },
        { text: 'F18', value: 'f18' },
        { text: 'F19', value: 'f19' },
        { text: 'F20', value: 'f20' },
        { text: 'F21', value: 'f21' },
        { text: 'F22', value: 'f22' },
        { text: 'F23', value: 'f23' },
        { text: 'F24', value: 'f24' },
        { text: 'F25', value: 'f25' },
        { text: 'F26', value: 'f26' },
        { text: '', value: 'delete' }
      ],
      table14: Table14,
      table15: Table15
    }
  },

  // Populate on create if data exists
  created: function (this:any) {
    this.getPaddockData()
    const stored = store.state.otherTools1
    if (stored !== null) {
      this.name = stored.name
      this.date = stored.date
      this.startDate = stored.startDate
      this.mobs = stored.mobs
      this.paddockData = stored.paddockData
      this.paddock = stored.paddock
      this.paddockHeaders = stored.paddockHeaders
    }
  },

  // Update state on component value changes
  updated: function (this:any) {
    store.dispatch('updateOtherTools1', this.$data)
  },

  // Update state on component destroy
  beforeDestroy: function (this:any) {
    store.dispatch('updateOtherTools1', this.$data)
  },

  watch: {
    // Update on start date change
    startDate: function (this:any) {
      this.getPaddockData()
    }
  },

  computed: {
    // List of mobs to select in paddock record
    mobItems: function (this:any) {
      return this.mobs.map((m:any) => {
        if (m.name) {
          return m.name
        }
      })
    },

    // Starting date for each fortnight
    fortnightDates: function (this:any) {
      let fortnightDates:any[] = []
      for (let i = 0; i < 26; i++) {
        fortnightDates.push(this.addFortnightsToDate(this.startDate, i))
      }
      return fortnightDates
    },

    // New paddock defaults
    newPaddock: function (this:any) {
      return {
        name: { display: 'input', type: 'text', value: this.paddock.name },
        area: { display: 'input', type: 'number', value: this.paddock.area },
        f1: { display: 'select', type: 'text', value: this.paddock.f1 },
        f2: { display: 'select', type: 'text', value: this.paddock.f2 },
        f3: { display: 'select', type: 'text', value: this.paddock.f3 },
        f4: { display: 'select', type: 'text', value: this.paddock.f4 },
        f5: { display: 'select', type: 'text', value: this.paddock.f5 },
        f6: { display: 'select', type: 'text', value: this.paddock.f6 },
        f7: { display: 'select', type: 'text', value: this.paddock.f7 },
        f8: { display: 'select', type: 'text', value: this.paddock.f8 },
        f9: { display: 'select', type: 'text', value: this.paddock.f9 },
        f10: { display: 'select', type: 'text', value: this.paddock.f10 },
        f11: { display: 'select', type: 'text', value: this.paddock.f11 },
        f12: { display: 'select', type: 'text', value: this.paddock.f12 },
        f13: { display: 'select', type: 'text', value: this.paddock.f13 },
        f14: { display: 'select', type: 'text', value: this.paddock.f14 },
        f15: { display: 'select', type: 'text', value: this.paddock.f15 },
        f16: { display: 'select', type: 'text', value: this.paddock.f16 },
        f17: { display: 'select', type: 'text', value: this.paddock.f17 },
        f18: { display: 'select', type: 'text', value: this.paddock.f18 },
        f19: { display: 'select', type: 'text', value: this.paddock.f19 },
        f20: { display: 'select', type: 'text', value: this.paddock.f20 },
        f21: { display: 'select', type: 'text', value: this.paddock.f21 },
        f22: { display: 'select', type: 'text', value: this.paddock.f22 },
        f23: { display: 'select', type: 'text', value: this.paddock.f23 },
        f24: { display: 'select', type: 'text', value: this.paddock.f24 },
        f25: { display: 'select', type: 'text', value: this.paddock.f25 },
        f26: { display: 'select', type: 'text', value: this.paddock.f26 },
        delete: { display: null, type: null, value: 'delete' }
      }
    },

    // Total farm paddock area
    totalArea: function (this:any) {
      let totalArea:number = 0
      this.paddockData.forEach((paddock:any) => {
        if (paddock.area.value) {
          totalArea += parseFloat(paddock.area.value)
        }
      })
      return totalArea
    },

    // Total head of stock
    totalNumber: function (this:any) {
      let totalNumber:number = 0
      this.mobs.forEach((mob:any) => {
        if (mob.number) {
          totalNumber += parseInt(mob.number)
        }
      })
      return totalNumber
    },

    // Total DSE Grazing Days
    totalDaysGrazing: function (this:any) {
      let totalDaysGrazing:number = 0
      this.paddockData.forEach((paddock:any) => {
        for (let prop in paddock) {
          if (prop.slice(0, 1) === 'f') {
            if (paddock[prop].value !== null && paddock[prop].value !== undefined) {
              let x = this.mobs.filter((m:any) => m.name === paddock[prop].value)[0]
              let days = 14
              if (x) {
                totalDaysGrazing += (x.number * x.dse * days)
              }
            }
          }
        }
      })
      return totalDaysGrazing
    }
  },

  methods: {
    // Get paddock data
    getPaddockData: function (this:any) {
      for (let i = 0; i < 1; i++) {
        this.$set(this.paddockData, i, this.cleanSource(this.newPaddock))
      }
    },

    // Add new mob
    addMob: function (this:any) {
      this.mobs.push({ name: 'New Mob...', class: null, colour: '#ffffff', number: 0, dse: 0 })
    },

    // Remove mob
    removeMob: function (this:any, index:number) {
      if (this.mobs.length > 1) {
        this.mobs.splice(index, 1)
      }
    },

    // Handle mob name change
    mobNameChange: function (this:any, newName:string, mobIndex:number) {
      let oldName = this.cleanSource(this.mobs[mobIndex].name)
      this.mobs[mobIndex].name = newName
      // update the paddock data
      this.paddockData.map((paddock:any) => {
        for (let prop in paddock) {
          if (prop.includes('f')) {
            if (paddock[prop].value === oldName) {
              paddock[prop].value = newName
            }
          }
        }
      })
      // Update the mob name
      this.mobs[mobIndex].name = newName
    },

    // Add new paddock
    addPaddock: function (this:any) {
      this.paddockData.push(this.cleanSource(this.newPaddock))
    },

    // Remove paddock
    removePaddock: function (this:any, index:number) {
      if (this.paddockData.length > 1) {
        this.paddockData.splice(index, 1)
      }
    },

    // Add fortnights to formatted date string dd/mm/yyyy
    addFortnightsToDate: function (this:any, date:any, increment:number) {
      return dayjs(date).add(increment * 2, 'weeks').format('D MMM')
    },

    // Using native JSON functions removes reactivity
    // so we can clone an object without mutating the original source
    cleanSource: function (source:any) {
      return JSON.parse(JSON.stringify(source))
    },

    // Load scenario data
    loadScenario: function (this:any, item:any) {
      this.paddockData = item.data1
      this.mobs = item.data2
      this.startDate = item.data3
    },

    // Print
    print: function (this:any) {
      print();
    }
  },

  components: {
    PageTitle, TableModal
  },

  store
}
